import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { Dropdown } from '@fluentui/react-components';

const AdaptedDropdown = ({
  errorMessage,
  onOptionSelect,
  updateValidation,
  useSearchLift,
  validationProps,
  ...restProps
}) => {
  const onSelect = useCallback((e, data) => {
    const { selectedOptions } = data;
    updateValidation(selectedOptions.length === 0 ? [errorMessage] : [], { selectedOptions });
    onOptionSelect(e, data);
  }, [errorMessage, onOptionSelect, updateValidation]);

  useEffect(() => {
    const selected = validationProps.data.selectedOptions;
    updateValidation(selected.length === 0 && useSearchLift ? [errorMessage] : [], { selectedOptions: selected });
  }, [errorMessage, updateValidation, useSearchLift, validationProps.data.selectedOptions]);

  return (
    <Dropdown
      {...restProps}
      onOptionSelect={onSelect}
      selectedOptions={validationProps.data.selectedOptions}
    />
  );
};

AdaptedDropdown.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  onOptionSelect: PropTypes.func.isRequired,
  useSearchLift: PropTypes.bool.isRequired,
  updateValidation: PropTypes.func.isRequired,
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      selectedOptions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ])).isRequired,
    }).isRequired,
  }).isRequired,
};

export const RequiredDropdown = withCustomValidation(AdaptedDropdown);
